import { AppProps, NextWebVitalsMetric } from "next/app";
import "../css/tailwind.css";
// @ts-ignore
import { AnalyticsProvider } from "use-analytics";
import Analytics from "analytics";
import AnalyticsInitializer from "@xtribe/shared/components/Analytics/AnalyticsInitializer";
import NProgress from "@xtribe/shared/components/nprogress";
// @ts-ignore
import segmentPlugin from "@analytics/segment";
import { init } from "@xtribe/shared/utils/sentry";
import * as Fathom from "fathom-client";
import { useTeam } from "@xtribe/shared/hooks/useTeam";
import { Provider } from "jotai";
import { QueryClient, QueryClientProvider } from "react-query";
import { Hydrate } from "react-query/hydration";
import { ReactQueryDevtools } from "react-query/devtools";
import { useRef } from "react";
import { useUser } from "@xtribe/shared/hooks/useUser";
import { useRouter } from "next/router";
import MediaUploadModal from "../components/Media/MediaUpload/MediaUploadModal";

init();
const fathomPlugin = {
  name: "fathom",
  page: ({ payload }: any) => {
    if (Fathom) {
      const url = payload.properties.url + payload.properties.path;
      Fathom.trackPageview({ url });
    }
  },
  track: ({ payload }: any) => {
    if (Fathom) {
      if (payload.event === "Studio Onboarding Start") {
        Fathom.trackGoal("BOEW0U3J", 0);
      } else if (payload.event === "Onboarding User Sign Up") {
        Fathom.trackGoal("CKKC2CDE", 0);
      } else if (payload.event === "Onboarding Team Create") {
        Fathom.trackGoal("WV0LDXJJ", 0);
      } else if (payload.event === "Onboarding Spaces Added") {
        Fathom.trackGoal("6JY4D9KN", 0);
      } else if (payload.event === "Onboarding Complete") {
        Fathom.trackGoal("A5HJOJU7", 0);
      } else if (payload.event === "Member Onboarding Start") {
        Fathom.trackGoal("OGWNFFYR", 0);
      }
    }
  },
};
const analytics = Analytics({
  app: "xtribe",
  plugins: [
    fathomPlugin,
    // segmentPlugin({ writeKey: "hCMsGlHAubSxqXLUoVG5J9m1yNigNiuC" }),
  ],
});
// analytics.plugins.disable("segment", () => null);

// export function reportWebVitals(metric: NextWebVitalsMetric) {
//   console.log(metric);
// }

export default function App({
  Component,
  pageProps,
  err,
}: AppProps & { err: any }) {
  const { team } = useTeam();
  const { user } = useUser();
  const router = useRouter();
  const queryClientRef = useRef<QueryClient | null>();
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient();
  }

  return (
    <>
      <QueryClientProvider client={queryClientRef.current}>
        <Hydrate state={pageProps.dehydratedState}>
          <AnalyticsProvider instance={analytics}>
            <AnalyticsInitializer>
              <Provider>
                {router.pathname.startsWith("/admin") && <MediaUploadModal />}
                <Component {...pageProps} err={err} />
                <NProgress />
              </Provider>
            </AnalyticsInitializer>
          </AnalyticsProvider>
          <ReactQueryDevtools />
        </Hydrate>
      </QueryClientProvider>
      {team?.branding && !router.pathname.startsWith("/admin") && (
        <style jsx global>{`
          :root {
            --color-primary-dark: #0b0a33;
            --color-primary: ${team.branding.primaryColor};
            --color-primary-light: #f1f7fd;
            --color-accent-dark: #0b0a33;
            --color-accent: ${team.branding.accentColor};
            --color-accent-light: #e2e2ff;
            --color-on-primary: ${team.branding.primaryTextColor};
            --color-on-accent: ${team.branding.accentTextColor};
            --color-background: #fff;
            --color-background-soft: #rgba(255, 255, 255, 0.62);
            --color-foreground: #121212;
            --color-foreground-soft: rgba(0, 0, 0, 0.62);
          }
        `}</style>
      )}
    </>
  );
}
